import { useAction, useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { useHapticFeedback } from '@blade/ui-kit'
import { premiumConfigAtom } from '@root/entities/premium'
import { PaymentWallets } from '@root/features/wallet/payment-wallets/ui/payment-wallets'
import { useTranslation } from '@root/shared/localization'
import { Separator } from '@root/shared/ui-kit'

import { PaymentDialogFormFields } from '../desktop/common/payment-dialog-form-fields'

import { BuyPremiumFormLink } from './buy-premium-form-link'
import { PaymentFormAction } from './payment-form-action'

import type { DeviceType } from '@blade/ui-kit'
import type { CurrencyModel } from '@root/entities/currency'
import type { PurchaseBoostersReatom } from '@root/features/premium/purchase-boosters'

type Props = {
  currency: CurrencyModel
  model: PurchaseBoostersReatom
  device: DeviceType
}

export const BuyPremiumForm: React.FC<Props> = ({ model, device }) => {
  const { t } = useTranslation()
  const haptics = useHapticFeedback()

  const [_, setPortalLink] = useAtom(model.portalLinkAtom)
  const [paymentSource, setPaymentSource] = useAtom(model.paymentSourceAtom)

  const purchase = useAction(model.purchaseBoostersAction)
  const [{ premiumBoosters, extendPremiumBoosters }] =
    useAtom(premiumConfigAtom)

  return (
    <Root
      noValidate
      onSubmit={(e) => {
        e.preventDefault()
        haptics.impactOccurred('light')
        purchase()
      }}
    >
      <BuyPremiumFormLink device={device} onChange={setPortalLink} />
      <Separator />
      <PaymentDialogFormFields type="premium" model={model} />
      <Note>
        {t('premium.pay.subscription.note', {
          boosts: premiumBoosters,
          extendBoosts: extendPremiumBoosters,
        })}
      </Note>
      <Separator />
      <PaymentWallets
        label={t('premium.pay.wallets.title')}
        device={device}
        paymentSource={paymentSource}
        setPaymentSource={setPaymentSource}
      />
      <PaymentFormAction product="premium" model={model} />
    </Root>
  )
}

const Root = styled.form`
  display: grid;
  gap: 16px;
`

const Note = styled.p`
  color: var(--text-7);

  text-align: center;
  justify-self: center;
  font-size: 13px;
  font-weight: 500;
  line-height: 20px;
`
